import { NgModule } from '@angular/core';
import {UppercaseDirective} from "@portal/shared/directives/uppercase.directive";

@NgModule({
    declarations: [UppercaseDirective],
    exports: [UppercaseDirective]
})
export class DirectivesModule {
}
